export default {
  mounted() {
    const regex = new RegExp(this.el.dataset.regex);

    this.el.addEventListener("keydown", (event) => {
      const isAllowedKey = ["Backspace", "ArrowLeft", "ArrowRight", "Delete", "Tab", "Enter"].includes(event.key);
      const isDigit = regex.test(event.key);

      if (!isDigit && !isAllowedKey) {
        event.preventDefault();
      }
    });
  }
}; 